import React from 'react'
import './Doctor.css'
import SectionOne from './SectionOne';
import SetionTwo from './SetionTwo';
import { IoIosArrowForward } from 'react-icons/io';
const Doctor = () => {
  return (
    <div className="page-title-bar page-title-bar-02">
      <div id="page-title-bar" className="page-title-bar page-title-bar-02">
        <div className="page-title-bar-overlay" />
        <div className="page-title-bar-inner" style={{backgroundImage:"url('/Images/doctor-consul.jpeg')"}}>
          <div className="container">
            <div className="row row-xs-center">
              <div className="col-md-6">
                <div className="page-title-bar-heading">
                  <h1 className="heading">Doctor Consultation </h1>
                </div>
              </div>
              <div className="col-md-6">
                <div id="page-breadcrumb" className="page-breadcrumb">
                  <div className="page-breadcrumb-inner">
                    <ul className="insight_core_breadcrumb">
                      <li className="level-1 top item-home">
                        <a>Home</a>
                      </li>
                      <IoIosArrowForward color="#fff" style={{position:'relative'}}/>
                      <li className="level-2 sub item-current tail current">
                        <span>Doctor Consultation</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SectionOne />
      <SetionTwo />
    </div>
  );
}

export default Doctor
